const defaultState = {
  clients: [],
  projectLeads: [],
  analysts: [],
  projectName: "",
  projectNumber: "",
  projectRduids: [],
  status: [],
  regulatoryRelated: [],
  metadataFilters: [],
  myProjectsFilter: false,
  projectsPerPage: 8,
  currentProjectPage: 1,
  listViewProjectPerPage: 20,
  projectSortType: '-created_date',
  listView: true,
  projectsHaveBeenSearched: false,


  deliverablesView: false,
  myDeliverablesFilter: true,
  showCompletedDeliverables: false,
  currentDeliverablesPage: 1,
  deliverableStatusFilter: ["On Going", "Past Due", "Not Started"],
  deliverableAssignedToFilter: [],
  deliverableSearchTerm: "",
  deliverableSortType: "-due_date",
  deliverablesHaveBeenSearched: false,
}

export default function manageProjectFilters(state = defaultState, action) {
  switch (action.type) {
    case "INPUT_CLIENTS":
      return { ...state, clients: action.payload }
    case "INPUT_PROJECT_LEADS":
      return { ...state, projectLeads: action.payload }
    case "INPUT_ANALYSTS":
      return { ...state, analysts: action.payload }
    case "INPUT_PROJECT_NAME":
      return { ...state, projectName: action.payload }
    case "INPUT_PROJECT_NUMBER":
      return { ...state, projectNumber: action.payload }
    case "INPUT_PROJECT_RDUIDS":
      return { ...state, projectRduids: action.payload }
    case "INPUT_STATUS":
      return { ...state, status: action.payload }
    case "INPUT_REGULATORY_RELATED":
      return { ...state, regulatoryRelated: action.payload }
    case "CHANGE_PROJECT_PAGE":
      return { ...state, currentProjectPage: action.payload }
    case "MY_PROJECT_SWITCH":
      return { ...state, myProjectsFilter: action.payload, currentProjectPage: 1, deliverablesView: false }
    case "TOGGLE_SHOW_COMPLETED_DELIVERABLES":
      return { ...state, showCompletedDeliverables: !state.showCompletedDeliverables }
    case "CHANGE_PROJECT_SORT_TYPE":
      return {...state, projectSortType: action.payload}
    case "CHANGE_PROJECT_VIEW":
      return {...state, listView: !state.listView}
    case "INPUT_METADATA_FILTERS":
      const { metadataValues, metadata } = action.payload
      let metadataFilters = state.metadataFilters.filter(value => value.metadata !== metadata)
      metadataFilters = [...metadataFilters, ...metadataValues]
      return { ...state, metadataFilters }
    case "CLEAR_METADATA_FILTERS":
      return {...state, metadataFilters: []}
    case "TOGGLE_PROJECTS_HAVE_BEEN_SEARCHED":
      return { ...state, projectsHaveBeenSearched: action.payload }
    case "CLEAR_ALL_PROJECT_FILTERS":
      return {
        ...state,
        clients: [],
        projectLeads: [],
        analysts: [],
        projectName: "",
        projectNumber: "",
        projectRduids: [],
        status: [],
        regulatoryRelated: [],
        metadataFilters: [],
        projectsHaveBeenSearched: false,
      }

      // Deliverable filter cases
    case "CHANGE_DELIVERABLES_PAGE":
      return { ...state, currentDeliverablesPage: action.payload }
    case "MY_DELIVERABLES_SWITCH":
      return { ...state, myDeliverablesFilter: action.payload, currentDeliverablesPage: 1, deliverablesView: true }
    case "CHANGE_DELIVERABLE_VIEW":
      if (!state.deliverablesView && !state.myProjectsFilter) {
        return {...state, deliverablesView: !state.deliverablesView, currentProjectPage: 1}
      }
      return {...state, deliverablesView: !state.deliverablesView}
    case "CHANGE_DELIVERABLE_SEARCH_TERM":
      return { ...state, deliverableSearchTerm: action.payload }
    case "CHANGE_DELIVERABLE_STATUS_FILTER":
      return { ...state, deliverableStatusFilter: action.payload }
    case "CHANGE_DELIVERABLE_ASSIGNED_TO_FILTER":
      return { ...state, deliverableAssignedToFilter: action.payload }
    case "CHANGE_DELIVERABLE_SORT_TYPE":
      return { ...state, deliverableSortType: action.payload }
    case "TOGGLE_DELIVERABLES_HAVE_BEEN_SEARCHED":
      return { ...state, deliverablesHaveBeenSearched: action.payload }
    case "CLEAR_ALL_DELIVERABLE_FILTERS":
      return {
        ...state,
        clients: [],
        projectLeads: [],
        analysts: [],
        deliverableStatusFilter: [],
        deliverableAssignedToFilter: [],
        deliverableSearchTerm: "",
        deliverablesHaveBeenSearched: false,
      }
    default:
      return state
  }
}

export const inputClients = (data) => {
  return { type: "INPUT_CLIENTS", payload: data }
}

export const inputProjectLeads = (data) => {
  return { type: "INPUT_PROJECT_LEADS", payload: data }
}

export const inputAnalysts = (data) => {
  return { type: "INPUT_ANALYSTS", payload: data }
}

export const inputProjectName = (projectName) => {
  return { type: "INPUT_PROJECT_NAME", payload: projectName }
}

export const inputProjectNumber = (data) => {
  return { type: "INPUT_PROJECT_NUMBER", payload: data }
}

export const inputProjectRduids = (data) => {
  return { type: "INPUT_PROJECT_RDUIDS", payload: data }
}

export const inputStatus = (data) => {
  return { type: "INPUT_STATUS", payload: data }
}

export const inputRegulatoryRelated = (data) => {
  return { type: "INPUT_REGULATORY_RELATED", payload: data }
}

export const changeProjectPage = (page) => {
  return { type: "CHANGE_PROJECT_PAGE", payload: page }
}

export const changeDeliverablesPage = (page) => {
  return { type: "CHANGE_DELIVERABLES_PAGE", payload: page }
}

export const myProjectSwitch = (data) => {
  return { type: "MY_PROJECT_SWITCH", payload: data }
}

export const myDeliverablesSwitch = (data) => {
  return { type: "MY_DELIVERABLES_SWITCH", payload: data }
}

export const toggleShowCompletedDeliverables = () => {
  return { type: "TOGGLE_SHOW_COMPLETED_DELIVERABLES" }
}

export const changeProjectSortType = (sortType) => {
  return { type: "CHANGE_PROJECT_SORT_TYPE", payload: sortType }
}

export const changeProjectView = () => {
  return { type: "CHANGE_PROJECT_VIEW" }
}

export const changeDeliverableView = () => {
  return { type: "CHANGE_DELIVERABLE_VIEW" }
}

export const inputMetadataFilters = (metadataValues, metadata) => {
  return { type: "INPUT_METADATA_FILTERS", payload: { metadataValues, metadata } }
}

export const clearMetadataFilters = () => {
  return { type: "CLEAR_METADATA_FILTERS" }
}

export const clearAllProjectFilters = () => {
  return { type: "CLEAR_ALL_PROJECT_FILTERS" }
}

export const toggleProjectsHaveBeenSearched = (haveBeenSearched) => {
  return { type: "TOGGLE_PROJECTS_HAVE_BEEN_SEARCHED", payload: haveBeenSearched }
}



export const changeDeliverableSortType = (sortType) => {
  return { type: "CHANGE_DELIVERABLE_SORT_TYPE", payload: sortType }
}

export const changeDeliverableSearchTerm = (searchTerm) => {
  return { type: "CHANGE_DELIVERABLE_SEARCH_TERM", payload: searchTerm }
}

export const changeDeliverableStatusFilter = (status) => {
  return { type: "CHANGE_DELIVERABLE_STATUS_FILTER", payload: status }
}

export const changeDeliverableAssignedToFilter = (users) => {
  return { type: "CHANGE_DELIVERABLE_ASSIGNED_TO_FILTER", payload: users }
}

export const clearAllDeliverableFilters = () => {
  return { type: "CLEAR_ALL_DELIVERABLE_FILTERS" }
}

export const toggleDeliverablesHaveBeenSearched = (haveBeenSearched) => {
  return { type: "TOGGLE_DELIVERABLES_HAVE_BEEN_SEARCHED", payload: haveBeenSearched }
}



// WEBPACK FOOTER //
// ./src/routes/projects/reducers/manageProjectFilters.js